<template>
  <div>
    <!--<h3>Report Charts</h3>-->
    <!--<input type="button" value="Run Report" @click="createReport" />-->
    <div class="reportChartView page right-side" size="A4"></div>
  </div>
</template>

<script>
  // import jsreports from '../lib/jsreports.js'
  import reportDef from './data/charts-report-def.json'
  import timeData from './data/time-data.json'
  import timeDataSchema from './data/time-data-schema.json'
  export default {
    name: 'reportCharts',
    props: {
      isActive: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
      }
    },
    created () {
      this.$root.title = 'Reports'
    },
    mounted () {
      // this.createReport()
    },
    watch: {
      isActive (val) {
        console.log('[reportCharts] isActive = ' + val)
        if (val) {
          this.createReport()
        }
      }
    },
    methods: {
      createReport () {
        // const vm = this
        var dataSource2 = [{
          id: 'time',
          name: 'Time',
          data: timeData,
          schema: timeDataSchema
        }]

        // console.log(dataSource1)
        // console.log(dataSource2)

        jsreports.render({
          report_def: reportDef,
          target: $('.reportChartView'),
          datasets: dataSource2
        })
      }
    }
  }
</script>

<style>
  .reportChartView {
    z-index: 200;
    min-height: 29.7cm;
  }

  .page {
    background: white;
    display: block;
    position: relative;
    min-height: 0;
    margin: 0 auto;
    padding: 0;
    margin-top: 0.5cm;
    margin-bottom: 0.5cm;
    /*box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);*/
    /*page-break-before: always;
    page-break-before: always;
    page-break-after: always;
    break-before: always;
    break-after: always;
    page-break-after: always;*/
    /*page-break-inside: avoid;*/
    page-break-after: always;
    page-break-inside: avoid;
  }

    .page[size="A4"] {
      width: 21cm;
      height: 29.7cm;
      /*height: 31.0cm;*/
      /*position: relative;*/
    }

      .page[size="A4"][layout="portrait"] {
        width: 29.7cm;
        height: 21cm;
      }

    .page[size="A3"] {
      width: 29.7cm;
      height: 42cm;
    }

      .page[size="A3"][layout="portrait"] {
        width: 42cm;
        height: 29.7cm;
      }

    .page[size="A5"] {
      width: 14.8cm;
      height: 21cm;
    }

      .page[size="A5"][layout="portrait"] {
        width: 21cm;
        height: 14.8cm;
      }
</style>



// WEBPACK FOOTER //
// ReportCharts.vue?5bc1b221